import React, { useCallback } from "react"
import { EntrySelector } from "@ciq/shared/components/modal"
import { useAppContext } from "@ciq/shared/hooks/context"

/**
 * Semester dropdown selector component.
 * Can be used in left panel or overlay.
 *
 * @param {Object} props - Component props
 * @param {string} [props.label="Semester"] - Label for the selector
 * @returns {React.ReactElement|null} Semester selector component
 */
export function SemesterSelector({ label = "Semester" }) {
  const { school, semester, setSemester } = useAppContext()

  const handleChange = useCallback(
    selected => {
      if (!selected) return
      // The value from EntrySelector is the full semester object
      setSemester(selected.value)
    },
    [setSemester]
  )

  if (!school || !semester) return null

  const formatSemester = s => ({ label: s.name, value: s })
  const semesterOptions = school.semesters.filter(s => s.id !== semester.id).map(formatSemester)

  return (
    <div className="semester-selector">
      <EntrySelector
        label={label}
        value={formatSemester(semester)}
        options={semesterOptions}
        onChange={handleChange}
      />
    </div>
  )
}
